import { COLORS } from '@/config/colors';
import { css, fillOutlined, circle, shade } from './draw-utils';
import type { ProceduralDef } from '../types';

const DEEP = 0x1f4e78; // abyssal body water
const FOAM = 0xbfe8ff;

/**
 * B7 Deep Caller — water Elemental. A towering droplet
 * body with a glowing abyss-lantern core and orbiting bubbles.
 * Frame 0 calm / 1 agitated (vortex). docs/02 Elementals.
 */
export const bossTideBody: ProceduralDef = {
  key: 'boss/tide/body',
  width: 130,
  height: 130,
  anchorX: 0.5,
  anchorY: 0.55,
  frames: 2,
  draw(ctx, w, h, frame) {
    const c = w / 2;
    const cy = h * 0.55;
    const agitated = frame === 1;

    // Cold glow
    const halo = ctx.createRadialGradient(c, cy, 24, c, cy, c);
    halo.addColorStop(0, agitated ? 'rgba(74, 184, 232, 0.45)' : 'rgba(74, 184, 232, 0.28)');
    halo.addColorStop(1, 'rgba(74, 184, 232, 0)');
    circle(ctx, c, cy, c);
    ctx.fillStyle = halo;
    ctx.fill();

    // Droplet body — peak leans when agitated
    const lean = agitated ? 10 : 0;
    ctx.beginPath();
    ctx.moveTo(c + lean, cy - 52);
    ctx.bezierCurveTo(c + 44, cy - 18, c + 40, cy + 26, c, cy + 38);
    ctx.bezierCurveTo(c - 40, cy + 26, c - 44, cy - 18, c + lean, cy - 52);
    ctx.closePath();
    fillOutlined(ctx, DEEP, 6.5);

    // Inner currents
    ctx.strokeStyle = css(shade(DEEP, 1.5));
    ctx.lineWidth = 3.5;
    ctx.lineCap = 'round';
    for (const [ox, oy, r0, r1] of [
      [-12, -6, 12, 0.6], [14, 4, 10, 2.4], [-2, 18, 9, 4.2],
    ] as const) {
      ctx.beginPath();
      ctx.arc(c + ox, cy + oy, r0, r1, r1 + 2.2);
      ctx.stroke();
    }

    // Abyss lantern core
    circle(ctx, c, cy - 4, agitated ? 14 : 11);
    fillOutlined(ctx, COLORS.abyssGlow, 3.5);
    circle(ctx, c - 3, cy - 8, 3.5);
    ctx.fillStyle = css(FOAM);
    ctx.fill();
    if (agitated) {
      circle(ctx, c, cy - 4, 20);
      ctx.fillStyle = 'rgba(74, 184, 232, 0.25)';
      ctx.fill();
    }

    // Orbiting droplets
    ctx.fillStyle = css(FOAM);
    for (const [ox, oy, r] of [[-44, -20, 5], [46, -8, 4], [30, -44, 4.5]] as const) {
      circle(ctx, c + ox, cy + oy, r);
      ctx.fill();
    }
    void h;
  },
};
